import { render, staticRenderFns } from "./dialog-set-lock-temporary.vue?vue&type=template&id=2c87fcc6&scoped=true&"
import script from "./dialog-set-lock-temporary.vue?vue&type=script&lang=js&"
export * from "./dialog-set-lock-temporary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87fcc6",
  null
  
)

export default component.exports